export enum IndiceModeType {
    percent = "percent",
    ac = "integer",
    amount = "amount"
}
